import type { GEOScoreData } from '@/services/api'

export type CheckResult = {
  id: string
  label: string
  desc: string
  weight: number
  passed: boolean
  score: number
}

export class GeoScoreMapper {
  static toCheckResults(geoScore: GEOScoreData): CheckResult[] {
    const checkResults: CheckResult[] = []

    for (const breakdown of geoScore.breakdown) {
      for (const check of breakdown.checks) {
        checkResults.push({
          id: `${breakdown.category}-${check.name}`.toLowerCase().replace(/\s+/g, '-'),
          label: check.name,
          desc: check.description || '',
          weight: check.weight,
          passed: check.passed,
          score: check.score,
        })
      }
    }

    return checkResults
  }
}

